import { Card } from 'react-bootstrap';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import OrganizationDetails from 'components/global/OrganizationsList/components/OrganizationDetails';
import { fetchOrganization } from 'components/global/OrganizationsList/OrganizationsList.helpers';
import BreadCrumbWrapper from 'components/global/BreadCrumbs/BreadCrumbs';
import { organizationDetailsSignal } from 'components/global/OrganizationsList/OrganizationsList.signal';
import { canPerformAction } from '../../../../libs/programAccessPermissions';
import userAccountSignal from '../../../../signals/UserAccount.signal';
import api from '../../../../api/api';
import loaderSignal from '../../../../signals/Loader.signal';

const EdoVcDetail = () => {
  const { pathname } = useLocation();
  const segments = pathname.split('/')
  const organizationId = segments[segments.length - 1];
  const { selectedOrganization } = organizationDetailsSignal.value;
  const [canViewMaintenance, setCanViewMaintenance] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  const labels = [
    segments[2] === 'vc' ? 'Venture Capitalists' : '',
    !!selectedOrganization ? selectedOrganization.name : '',
  ];

  // Check if user has canViewMaintenance permission on any program
  useEffect(() => {
    const checkViewMaintenancePermission = async () => {
      try {
        loaderSignal.update({ isContentLoading: true });
        // Fetch funding programs for the EDO
        const fundingPrograms = await api.get({
          path: '/fundingPrograms',
          options: {
            where: {
              edoId: userAccountSignal.value.userData?.account.edoId,
            },
          },
        });

        if (!fundingPrograms || fundingPrograms.length === 0) {
          setCanViewMaintenance(false);
          setIsChecking(false);
          return;
        }

        // Check if user has canViewMaintenance permission on any program
        const viewChecks = await Promise.all(
          fundingPrograms.map((program) =>
            canPerformAction(program.id, 'canViewMaintenance')
          )
        );

        setCanViewMaintenance(viewChecks.some((hasPermission) => hasPermission));
      } catch (error) {
        console.error('Error checking view maintenance permission:', error);
        setCanViewMaintenance(false);
      } finally {
        setIsChecking(false);
        loaderSignal.reset();
      }
    };

    checkViewMaintenancePermission();
  }, []);

  const init = useCallback(async () => {
    if (canViewMaintenance) {
      await fetchOrganization(organizationId, '/ventureCapitalFirms');
    }
  }, [organizationId, canViewMaintenance]);

  useEffect(() => {
    init();
  }, [init]);

  if (isChecking) {
    return (
      <BreadCrumbWrapper labels={labels}>
        <Card>
          <Card.Body>
            <p className="text-center">Loading...</p>
          </Card.Body>
        </Card>
      </BreadCrumbWrapper>
    );
  }

  if (!canViewMaintenance) {
    return (
      <BreadCrumbWrapper labels={labels}>
        <Card>
          <Card.Body>
            <h3 className="text-center">Access Denied</h3>
            <p className="text-center">
              You do not have permission to view VC details.
            </p>
          </Card.Body>
        </Card>
      </BreadCrumbWrapper>
    );
  }

  return (
    <BreadCrumbWrapper labels={labels}>
      <Card>
        <Card.Body>
          <OrganizationDetails />
        </Card.Body>
      </Card>
    </BreadCrumbWrapper>
  );
};

export default EdoVcDetail;
